import { computed } from "vue";
import { useAxureCloudConfig } from "./useAxureCloudConfig";

export function useIsOnPrem() {
  const config = useAxureCloudConfig();
  return computed(() => config.value?.AxShareOnPrem ?? false);
}
